import { apiSlice } from "./api";

const slice = apiSlice.injectEndpoints({
	endpoints: (build) => ({
		addVehicle: build.mutation({
			query: (body) => {
				return {
					url: "vms/vehicle/add-vehicle",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["vehicle"],
		}),
		getVehicles: build.query({
			query: (body) => {
				return {
					url: "vms/vehicle/get-vehicle",
					method: "post",
					body,
				};
			},
			providesTags: ["vehicle"],
		}),
		getVehiclesMutation: build.mutation({
			query: (body) => {
				return {
					url: "vms/vehicle/get-vehicle",
					method: "post",
					body,
				};
			},
		}),
		updateVehicle: build.mutation({
			query: (body) => {
				return {
					url: "vms/vehicle/update-vehicle",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["vehicle"],
		}),
		updateVehicleNumberInTrip: build.mutation({
			query: (body) => {
				return {
					url: "vms/vehicle/update-vehicle-number-in-trip",
					method: "post",
					body,
				};
			},
		}),
		deleteVehicle: build.mutation({
			query: (body) => {
				return {
					url: "vms/vehicle/delete-vehicle",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["vehicle"],
		}),
		vehicleDetails: build.mutation({
			query: (body) => {
				return {
					url: "vms/vehicle/vehicle-entry-data-list",
					method: "post",
					body,
				};
			},
			// providesTags: ["vehicle"],
		}),
		addSupplier: build.mutation({
			query: (body) => {
				return {
					url: "vms/supplier/add-supplier",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["supplier"],
		}),
		uploadBulkSupplier: build.mutation({
			query: (body) => {
				return {
					url: "vms/supplier/bulkUpload-supplier",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["supplier"],
		}),
		getSuppliers: build.mutation({
			query: (body) => {
				return {
					url: "vms/supplier/get-supplier",
					method: "post",
					body,
				};
			},
			providesTags: ["supplier"],
		}),
		updateSupplier: build.mutation({
			query: (body) => {
				return {
					url: "vms/supplier/update-supplier",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["supplier"],
		}),
		deleteSupplier: build.mutation({
			query: (body) => {
				return {
					url: "vms/supplier/delete-supplier",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["supplier"],
		}),

		addProduct: build.mutation({
			query: (body) => {
				return {
					url: "vms/product/add-product",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["productType"],
		}),
		uploadBulkProduct: build.mutation({
			query: (body) => {
				return {
					url: "vms/product/bulkUpload-product",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["productType"],
		}),
		getProducts: build.mutation({
			query: (body) => {
				return {
					url: "vms/product/get-product",
					method: "post",
					body,
				};
			},
			providesTags: ["productType"],
		}),
		updateProduct: build.mutation({
			query: (body) => {
				return {
					url: "vms/product/update-product",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["productType"],
		}),
		deleteProduct: build.mutation({
			query: (body) => {
				return {
					url: "vms/product/delete-product",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["productType"],
		}),

		addProductCategory: build.mutation({
			query: (body) => {
				return {
					url: "vms/product-category/add-product-category",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["productCategory"],
		}),
		uploadProductCategory: build.mutation({
			query: (body) => {
				return {
					url: "vms/product-category/bulkUpload-product-category",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["productCategory"],
		}),
		getProductCategories: build.mutation({
			query: (body) => {
				return {
					url: "vms/product-category/get-product-category",
					method: "post",
					body,
				};
			},
			providesTags: ["productCategory"],
		}),
		updateProductCategory: build.mutation({
			query: (body) => {
				return {
					url: "vms/product-category/update-product-category",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["productCategory"],
		}),
		deleteProductCategory: build.mutation({
			query: (body) => {
				return {
					url: "vms/product-category/delete-product-category",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["productCategory"],
		}),

		addCheckPoint: build.mutation({
			query: (body) => {
				return {
					url: "vms/checkpoint/add-checkpoint",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["CheckPoint"],
		}),
		getCheckPoint: build.query({
			query: (body) => {
				return {
					url: "vms/checkpoint/checkpoint-list",
					method: "post",
					body,
				};
			},
			providesTags: ["CheckPoint"],
		}),
		getCheckPoint: build.mutation({
			query: (body) => {
				return {
					url: "vms/checkpoint/checkpoint-list",
					method: "post",
					body,
				};
			},
			providesTags: ["CheckPoint"],
		}),
		getCheckPointOnCall: build.mutation({
			query: (body) => {
				return {
					url: "vms/checkpoint/checkpoint-list",
					method: "post",
					body,
				};
			},
			providesTags: ["CheckPoint"],
		}),
		getCheckPointDetail: build.query({
			query: (body) => {
				return {
					url: "vms/checkpoint/checkpoint-detail",
					method: "post",
					body,
				};
			},
		}),
		getCheckPointType: build.query({
			query: (body) => {
				return {
					url: "vms/checkpoint/get-checkpoint-type",
					method: "post",
					body,
				};
			},
		}),
		updateCheckPoint: build.mutation({
			query: (body) => {
				return {
					url: "vms/checkpoint/update-checkpoint",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["CheckPoint"],
		}),
		deleteCheckPoint: build.mutation({
			query: (body) => {
				return {
					url: "vms/checkpoint/delete-checkpoint",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["CheckPoint"],
		}),

		getTemplateList: build.query({
			query: (body) => {
				return {
					url: "builder/template_list",
					method: "post",
					body,
				};
			},
		}),
		getTemplates: build.mutation({
			query: (body) => {
				return {
					url: "builder/template_list",
					method: "post",
					body,
				};
			},
		}),
		getTemplateDetail: build.query({
			query: (body) => {
				return {
					url: "builder/template_detail",
					method: "post",
					body,
				};
			},
		}),
		getTemplateDetailOnCall: build.mutation({
			query: (body) => {
				return {
					url: "builder/template_detail",
					method: "post",
					body,
				};
			},
		}),
		uploadOfflineData: build.mutation({
			query: (body) => {
				return {
					url: "vms/vehicle/create-vehicle-entry",
					method: "post",
					body,
				};
			},
		}),
		saveCheckpointForm: build.mutation({
			queryFn: async (arg, api, extraOptions, baseQuery) => {
				// console.log(arg);
				const [url, body] = arg;

				try {
					const { data } = await baseQuery({ url, method: "post", body }, api, extraOptions);
					return { data };
				} catch (error) {
					return { error };
				}
			},
			invalidatesTags: ["checkpoint_datalist"],
		}),

		getCheckpointDataList: build.query({
			queryFn: async (arg, api, extraOptions, baseQuery) => {
				// console.log(arg);
				// const [url, body] = arg;
				let url = "vms/vehicle/checkpoint-data-list";
				let body = arg;

				try {
					const { data } = await baseQuery({ url, method: "post", body }, api, extraOptions);
					return { data };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ["checkpoint_datalist"],
		}),

		getCheckpointDataListForExcelDownload: build.mutation({
			queryFn: async (arg, api, extraOptions, baseQuery) => {
				// console.log(arg);
				// const [url, body] = arg;
				let url = "vms/vehicle/checkpoint-data-list";
				let body = arg;

				try {
					const { data } = await baseQuery({ url, method: "post", body }, api, extraOptions);
					return { data };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ["checkpoint_datalist"],
		}),
		getTripDetail: build.mutation({
			queryFn: async (arg, api, extraOptions, baseQuery) => {
				let url = "/vms/vehicle/find-trips";
				let body = arg;

				try {
					const { data } = await baseQuery({ url, method: "post", body }, api, extraOptions);
					return { data };
				} catch (error) {
					return { error };
				}
			},
		}),

		saveCheckoutForm: build.mutation({
			queryFn: async (arg, api, extraOptions, baseQuery) => {
				// console.log(arg);
				const [url, body] = arg;

				try {
					const { data } = await baseQuery({ url, method: "post", body }, api, extraOptions);
					return { data };
				} catch (error) {
					return { error };
				}
			},
			invalidatesTags: ["checkpoint_datalist"],
		}),

		getCheckpointEntryDetail: build.query({
			queryFn: async (arg, api, extraOptions, baseQuery) => {
				// console.log(arg);
				const [url, body] = arg;

				try {
					const { data } = await baseQuery({ url, method: "post", body }, api, extraOptions);
					return { data };
				} catch (error) {
					return { error };
				}
			},
		}),

		getDashboardStats: build.mutation({
			query: (body) => {
				return {
					url: "vms/vehicle/get-dashboard-stats",
					method: "post",
					body,
				};
			},
			providesTags: ["dashboard_stats"],
		}),
		getVehicleMovementStats: build.mutation({
			query: (body) => {
				return {
					url: "/vms/vehicle/vehicle-movement-stats",
					method: "post",
					body,
				};
			},
			providesTags: ["vehicle_movement_stats"],
		}),

		getDashboardStatsV2: build.mutation({
			query: (body) => {
				return {
					url: "vms/vehicle/dashboard-stats-v2",
					method: "post",
					body,
				};
			},
			providesTags: ["dashboard_stats"],
		}),

		getApiListDetail: build.query({
			query: (body) => {
				return {
					url: "builder/api_list",
					method: "post",
					body,
				};
			},
		}),

		getWorkflowListing: build.query({
			query: (body) => {
				return {
					url: "vms/vehicle/workflow-listing",
					method: "post",
					body,
				};
			},
			providesTags: ["workflowlist"],
		}),

		getWorkflowList: build.mutation({
			query: (body) => {
				return {
					url: "vms/vehicle/workflow-listing",
					method: "post",
					body,
				};
			},
			providesTags: ["workflowlist"],
		}),

		createWorkflow: build.mutation({
			query: (body) => {
				return {
					url: "vms/vehicle/create-workflow",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["workflowlist"],
		}),

		updateWorkflow: build.mutation({
			query: (body) => {
				return {
					url: "vms/vehicle/update-workflow",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["workflowlist"],
		}),

		customizeTripWorkflow: build.mutation({
			query: (body) => {
				return {
					url: "vms/vehicle/customize-trip-workflow",
					method: "post",
					body,
				};
			},
		}),
		getApprovalListing: build.query({
			query: (body) => {
				return {
					url: "vms/approval/Get-Approval-listing",
					method: "post",
					body,
				};
			},
			providesTags: ["approvallist"],
		}),

		updateApproval: build.mutation({
			query: (body) => {
				return {
					url: "vms/approval/approve",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["approvallist"],
		}),

		addCheckpointType: build.mutation({
			query: (body) => {
				return {
					url: "vms/checkpoint/add-checkpoint-type",
					method: "post",
					body,
				};
			},
		}),
		getCheckpointType: build.mutation({
			query: (body) => {
				return {
					url: "vms/checkpoint/get-checkpoint-type",
					method: "post",
					body,
				};
			},
		}),
		updateCheckpointType: build.mutation({
			query: (body) => {
				return {
					url: "vms/checkpoint/update-checkpoint-type",
					method: "post",
					body,
				};
			},
		}),
		deleteCheckpointType: build.mutation({
			query: (body) => {
				return {
					url: "vms/checkpoint/delete-checkpoint-type",
					method: "post",
					body,
				};
			},
		}),
		getTripcheckpoint: build.mutation({
			query: (body) => {
				return {
					url: "vms/checkpoint/get-trip-checkpoints",
					method: "post",
					body,
				};
			},
		}),
		getDataFromUlip: build.mutation({
			query: (body) => {
				return {
					url: "vms/vehicle/get-data-from-ulip",
					method: "post",
					body,
				};
			},
		}),
		mapVehicleTag: build.mutation({
			query: (body) => {
				return {
					url: "devices/tag/map-vehicle-tag",
					method: "post",
					body,
				};
			},
		}),
		createDynamicModule: build.mutation({
			query: (body) => {
				return {
					url: "vms/module/create-module",
					method: "post",
					body,
				};
			},
		}),
		getDynamicModule: build.mutation({
			query: (body) => {
				return {
					url: "vms/module/get-modules",
					method: "post",
					body,
				};
			},
		}),
		updateDynamicModule: build.mutation({
			query: (body) => {
				return {
					url: "vms/module/update-module",
					method: "post",
					body,
				};
			},
		}),
		deleteDynamicModule: build.mutation({
			query: (body) => {
				return {
					url: "vms/module/delete-module",
					method: "post",
					body,
				};
			},
		}),

		createDynamicModuleEntry: build.mutation({
			query: (body) => {
				return {
					url: "vms/dynamic-module/create-entry",
					method: "post",
					body,
				};
			},
		}),
		getDynamicModuleEntry: build.mutation({
			query: (body) => {
				return {
					url: "vms/dynamic-module/get-entries",
					method: "post",
					body,
				};
			},
		}),
		updateDynamicModuleEntry: build.mutation({
			query: (body) => {
				return {
					url: "vms/dynamic-module/update-entry",
					method: "post",
					body,
				};
			},
		}),
		deleteDynamicModuleEntry: build.mutation({
			query: (body) => {
				return {
					url: "vms/dynamic-module/delete-entry",
					method: "post",
					body,
				};
			},
		}),
		getApprovalConfigg: build.query({
			query: (body) => {
				return {
					url: "vms/approval-config/get-approval-config",
					method: "post",
					body,
				};
			},
			providesTags: ["approvalConfig"],
		}),
		addApprovalConfig: build.mutation({
			query: (body) => {
				return {
					url: "vms/approval-config/add-approval-config",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["approvalConfig"],
		}),
		updateApprovalConfig: build.mutation({
			query: (body) => {
				return {
					url: "vms/approval-config/update-approval-config",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["approvalConfig"],
		}),
		deleteApprovalConfig: build.mutation({
			query: (body) => {
				return {
					url: "vms/approval-config/delete-approval-config",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["approvalConfig"],
		}),
		getVariableListing: build.mutation({
			query: (body) => {
				return {
					url: "vms/common/get-org-variables",
					method: "post",
					body,
				};
			},
		}),
		getApprovalConfig: build.mutation({
			query: (body) => {
				return {
					url: "vms/approval-config/get-approval-config",
					method: "post",
					body,
				};
			},
		}),

		getOrgSetting: build.query({
			query: (body) => {
				return {
					url: "vms/common/get-org-setting",
					method: "post",
					body,
				};
			},
			providesTags: ["orgSetting"],
		}),
		getFile: build.mutation({
			query: (body) => {
				return {
					url: "vms/common/get-file",
					method: "post",
					body,
				};
			},
		}),
		updateOrgSetting: build.mutation({
			query: (body) => {
				return {
					url: "vms/common/update-org-setting",
					method: "post",
					body,
				};
			},
			invalidatesTags: ["orgSetting"],
		}),
		getApprovalDetail: build.mutation({
			query: (body) => {
				return {
					url: "vms/approval-config/get-approval-detail",
					method: "post",
					body,
				};
			},
		}),
		addRuleDetail: build.mutation({
			query: (body) => {
				return {
					url: "/vms/rule/create-rule",
					method: "post",
					body,
				};
			},
		}),
		updateRuleDetail: build.mutation({
			query: (body) => {
				return {
					url: "/vms/rule/update-rule",
					method: "post",
					body,
				};
			},
		}),
		getRuleDetail: build.mutation({
			query: (body) => {
				return {
					url: "/vms/rule/get-rules",
					method: "post",
					body,
				};
			},
		}),
		deleteRuleDetail: build.mutation({
			query: (body) => {
				return {
					url: "/vms/rule/delete-rule",
					method: "post",
					body,
				};
			},
		}),
		getEmailTemplates: build.mutation({
			query: (body) => ({ url: "/vms/rule/get-email-templates", method: "post", body }),
		}),
		addEmailTemplate: build.mutation({
			query: (body) => ({ url: "/vms/rule/create-email-template", method: "post", body }),
		}),
		updateEmailTemplate: build.mutation({
			query: (body) => ({ url: "/vms/rule/update-email-template", method: "post", body }),
		}),
		deleteEmailTemplate: build.mutation({
			query: (body) => ({ url: "/vms/rule/delete-email-template", method: "post", body }),
		}),
		getThirdPartyLogs: build.mutation({
			query: (body) => {
				return {
					url: "/vms/common/third-party-logs",
					method: "post",
					body,
				};
			},
		}),
		getUserTableHeaders: build.mutation({
			query: (body) => {
				return {
					url: "builder/get_user_table_header",
					method: "post",
					body,
				};
			},
		}),
		updateUserTableHeaders: build.mutation({
			query: (body) => {
				return {
					url: "builder/update_user_table_header",
					method: "post",
					body,
				};
			},
		}),
		getPlant: build.mutation({
			query: (body) => {
				return {
					url: "vms/plant/get-plants",
					method: "post",
					body,
				};
			},
		}),
		addPlant: build.mutation({
			query: (body) => {
				return {
					url: "vms/plant/create-plant",
					method: "post",
					body,
				};
			},
		}),
		updatePlant: build.mutation({
			query: (body) => {
				return {
					url: "vms/plant/update-plant",
					method: "post",
					body,
				};
			},
		}),
		deletePlant: build.mutation({
			query: (body) => {
				return {
					url: "vms/plant/delete-plant",
					method: "post",
					body,
				};
			},
		}),
		getStateOffices: build.mutation({
			query: (body) => {
				return {
					url: "vms/common/get-state",
					method: "post",
					body,
				};
			},
		}),
		getRegionalOffices:build.mutation({
			query: (body) => {
				return {
					url: "vms/common/get-regional-office",
					method: "post",
					body,
				};
			},
		}),

		addResource: build.mutation({
			query: (body) => {
				return {
					url: "vms/resource/add-resource",
					method: "post",
					body,
				};
			},
		}),

		getResource: build.mutation({
			query: (body) => {
				return {
					url: "vms/resource/get-resource",
					method: "post",
					body,
				};
			},
		}),

		updateResource: build.mutation({
			query: (body) => {
				return {
					url: "vms/resource/update-resource",
					method: "post",
					body,
				};
			},
		}),
		deleteResource: build.mutation({
			query: (body) => {
				return {
					url: "vms/resource/delete-resource",
					method: "post",
					body,
				};
			},
		}),
		getResourceUrl: build.mutation({
			query: (body) => {
				return {
					url: "vms/resource/get-resource-url",
					method: "post",
					body,
				};
			},
		}),
		triggerLed: build.mutation({
			query: (body) => {
				return {
					url: "vms/vehicle/trigger-led",
					method: "post",
					body,
				};
			},
		}),
		factoryDashboardData: build.mutation({
			query: (body) => {
				return {
					url: "vms/vehicle/get-checkpoints-insights",
					method: "post",
					body,
				};
			},
		}),
		getOrgInsights: build.mutation({
			query: (body) => {
				return {
					url: "vms/vehicle/get-org-insights",
					method: "post",
					body,
				};
			},
		}),
		getAvgTripTime: build.mutation({
			query: (body) => {
				return {
					url: "vms/vehicle/avg-trip-time",
					method: "post",
					body,
				};
			},
		}),
		addPlantComment: build.mutation({
			query: (body) => {
				return {
					url: "vms/plant/add-plant-comment",
					method: "post",
					body,
				};
			},
		}),
		viewPlantComment: build.mutation({
			query: (body) => {
				return {
					url: "vms/plant/view-plant-comment",
					method: "post",
					body,
				};
			},
		}),
		checkpointEventInsights: build.mutation({
			query: (body) => {
				return {
					url: "/vms/vehicle/checkpoint-event-insights",
					method: "post",
					body,
				};
			},
		}),
	}),
	overrideExisting: false,
});

// console.log(slice);
export const {
	useAddVehicleMutation,
	useGetVehiclesQuery,
	useGetVehiclesMutationMutation,
	useUpdateVehicleMutation,
	useUpdateVehicleNumberInTripMutation,
	useDeleteVehicleMutation,
	useVehicleDetailsMutation,
	useUploadOfflineDataMutation,

	useAddSupplierMutation,
	useUploadBulkSupplierMutation,
	useGetSuppliersMutation,
	useUpdateSupplierMutation,
	useDeleteSupplierMutation,

	useAddProductMutation,
	useUploadBulkProductMutation,
	useGetProductsMutation,
	useUpdateProductMutation,
	useDeleteProductMutation,

	useAddProductCategoryMutation,
	useUploadProductCategoryMutation,
	useGetProductCategoriesMutation,
	useUpdateProductCategoryMutation,
	useDeleteProductCategoryMutation,

	useAddCheckPointMutation,
	useGetCheckPointQuery,
	useGetCheckPointMutation,
	useGetCheckPointTypeQuery,
	useGetCheckPointOnCallMutation,
	useGetCheckPointDetailQuery,
	useUpdateCheckPointMutation,
	useDeleteCheckPointMutation,
	useGetTripcheckpointMutation,

	useGetTemplateDetailQuery,
	useGetTemplateListQuery,
	useGetTemplatesMutation,

	useSaveCheckpointFormMutation,
	useLazyGetCheckpointDataListQuery,
	useGetTripDetailMutation,
	useSaveCheckoutFormMutation,
	useLazyGetCheckpointEntryDetailQuery,

	useGetDashboardStatsMutation,
	useGetDashboardStatsV2Mutation,
	useGetVehicleMovementStatsMutation,
	useGetApiListDetailQuery,

	useCreateWorkflowMutation,
	useUpdateWorkflowMutation,
	useGetWorkflowListMutation,
	useGetWorkflowListingQuery,

	useCustomizeTripWorkflowMutation,

	useUpdateApprovalMutation,
	useGetApprovalListingQuery,

	useAddCheckpointTypeMutation,
	useGetCheckpointTypeMutation,
	useUpdateCheckpointTypeMutation,
	useDeleteCheckpointTypeMutation,

	useGetDataFromUlipMutation,
	useMapVehicleTagMutation,

	useGetDynamicModuleMutation,
	useCreateDynamicModuleMutation,
	useUpdateDynamicModuleMutation,
	useDeleteDynamicModuleMutation,

	useGetDynamicModuleEntryMutation,
	useCreateDynamicModuleEntryMutation,
	useUpdateDynamicModuleEntryMutation,
	useDeleteDynamicModuleEntryMutation,

	useGetApprovalConfiggQuery,
	useAddApprovalConfigMutation,
	useUpdateApprovalConfigMutation,
	useDeleteApprovalConfigMutation,

	useGetVariableListingMutation,
	useGetApprovalConfigMutation,
	useGetTemplateDetailOnCallMutation,

	useGetOrgSettingQuery,
	useUpdateOrgSettingMutation,

	useGetApprovalDetailMutation,

	useAddRuleDetailMutation,
	useUpdateRuleDetailMutation,
	useGetRuleDetailMutation,
	useDeleteRuleDetailMutation,
	useGetEmailTemplatesMutation,
	useAddEmailTemplateMutation,
	useUpdateEmailTemplateMutation,
	useDeleteEmailTemplateMutation,

	useGetThirdPartyLogsMutation,
	useGetFileMutation,

	useGetUserTableHeadersMutation,
	useUpdateUserTableHeadersMutation,

	useAddPlantMutation,
	useGetPlantMutation,
	useUpdatePlantMutation,
	useDeletePlantMutation,
	useGetStateOfficesMutation,
	useGetRegionalOfficesMutation,

	useAddResourceMutation,
	useGetResourceMutation,
	useUpdateResourceMutation,
	useDeleteResourceMutation,
	useGetResourceUrlMutation,
	useTriggerLedMutation,
	useFactoryDashboardDataMutation,
	useGetOrgInsightsMutation,
	useAddPlantCommentMutation,
	useGetCheckpointDataListForExcelDownloadMutation,
	useViewPlantCommentMutation,
	useGetAvgTripTimeMutation,
	useCheckpointEventInsightsMutation,
} = slice;
